export const DEFAULT_LOGO_URL =
  "https://static.readdy.ai/image/5bb0e04c11c0331c3337356b97ecb5ff/022ca6d7df2ebfad59cc8e2f172f2075.png";

export const BRAND_NAME = "Sistema RKC";
export const BRAND_TAGLINE = "Neumáticos & Servicios en General";

export interface SelectOption {
  value: string;
  label: string;
}

export const CUSTOMER_TYPE_OPTIONS: SelectOption[] = [
  { value: "regular", label: "Cliente regular" },
  { value: "mayorista", label: "Mayorista" },
];

export const CUSTOMER_TYPE_LABELS: Record<string, string> = {
  regular: "Regular",
  mayorista: "Mayorista",
};

export const VEHICLE_TYPE_OPTIONS: SelectOption[] = [
  { value: "Automóvil", label: "Automóvil" },
  { value: "Camioneta", label: "Camioneta / SUV" },
  { value: "Motor", label: "Motor / Motocicleta" },
  { value: "Camión", label: "Camión" },
  { value: "Autobús", label: "Autobús" },
  { value: "Otro", label: "Otro" },
];

export const SERVICE_CATEGORY_OPTIONS: SelectOption[] = [
  { value: "Montaje", label: "Montaje" },
  { value: "Balanceo", label: "Balanceo" },
  { value: "Alineación", label: "Alineación" },
  { value: "Reparación", label: "Reparación" },
  { value: "Cambio de aceite", label: "Cambio de aceite" },
  { value: "Mecánica general", label: "Mecánica general" },
  { value: "Otro", label: "Otro" },
];

export const OFFER_SCOPE_OPTIONS: SelectOption[] = [
  { value: "product", label: "Producto específico" },
  { value: "category", label: "Categoría completa" },
];

export const OFFER_DISCOUNT_TYPE_OPTIONS: SelectOption[] = [
  { value: "percentage", label: "Porcentaje (%)" },
  { value: "fixed", label: "Monto fijo (RD$)" },
  { value: "special_price", label: "Precio especial (RD$)" },
];

export const OFFER_DISCOUNT_LABELS: Record<string, string> = {
  percentage: "% de descuento",
  fixed: "Monto fijo",
  special_price: "Precio especial",
};